import { FC } from 'react';

interface Props {
    onClick?: () => void;
}

const EditIcon: FC<Props> = ({
    onClick = () => {
        return;
    },
}) => {
    return (
        <svg
            onClick={onClick}
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.83958 3.56669L3.36624 9.36002C3.15958 9.58002 2.95958 10.0134 2.91958 10.3134L2.67291 12.4734C2.58624 13.2534 3.14624 13.7867 3.91958 13.6534L6.06624 13.2867C6.36624 13.2334 6.78624 13.0134 6.99291 12.7867L12.4662 6.99336C13.4129 5.99336 13.8396 4.85336 12.3662 3.46002C10.8996 2.08002 9.78624 2.56669 8.83958 3.56669Z"
                stroke="#005092"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.92676 4.53333C8.21342 6.37333 9.70676 7.77999 11.5601 7.96666"
                stroke="#005092"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default EditIcon;
